export default __webpack_public_path__ + "static/media/login-logo.cfe06767.png";